import { GameConstants } from "../../../../GameConstants";
import { GameVars } from "../../../../GameVars";
import { BoardContainer } from "../../board-container/BoardContainer";
import { BattleManager } from "../../BattleManager";
import { AudioManager } from "../../../../AudioManager";
import * as Anuto from "../../../../../engine/src";
import { BattleScene } from "../../BattleScene";

export class RocketActor extends Phaser.GameObjects.Container {

    public anutoMortar: Anuto.Mortar;

    private mortarImage: Phaser.GameObjects.Image;
    private detonated: boolean;
    private f: number;
    
    constructor(scene: Phaser.Scene, anutoMortar: Anuto.Mortar) {

        super(scene);

        this.anutoMortar = anutoMortar;
        this.detonated = false;
        this.f = 0;

        this.x = this.anutoMortar.x * GameConstants.CELLS_SIZE;
        this.y = this.anutoMortar.y * GameConstants.CELLS_SIZE;

        this.mortarImage = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_2", "torre_5_municion_" + anutoMortar.turret.level);
        this.mortarImage.setScale(.5);
        this.add(this.mortarImage);

        AudioManager.playSound("rocket_launch");
    }

    public update(time: number, delta: number): void {

        if (this.detonated) {
            return;
        }

        // cambiar la escala para dar la sensacion de altura
        const tick = BattleManager.anutoEngine.ticksCounter;
        const dt = tick - this.anutoMortar.creationTick;
        let scale: number;

        // la escala crece
        if (dt < this.anutoMortar.ticksToImpact / 2) {
            scale = .9 * ( 1 + dt / (this.anutoMortar.ticksToImpact / 2));
        } else {
            // la escala disminuye
            scale = .9 * ( 1 +  (this.anutoMortar.ticksToImpact - dt) / (this.anutoMortar.ticksToImpact / 2)); 
        }

        this.mortarImage.setScale(scale);

        let smoothFactor: number;

        if (GameConstants.INTERPOLATE_TRAJECTORIES) {
            smoothFactor = GameVars.timeStepFactor === 1 ? .2 : .65;
        } else {
            smoothFactor = 1;
        }

        let offDistY = Math.sin((dt / this.anutoMortar.ticksToImpact) * Math.PI);
        let maxY = this.anutoMortar.ticksToImpact * 10;

        let offX = (this.anutoMortar.x * GameConstants.CELLS_SIZE - this.x) * smoothFactor;
        let offY = (this.anutoMortar.y * GameConstants.CELLS_SIZE - 40 * (dt / this.anutoMortar.ticksToImpact) - this.y + offDistY * - maxY) * smoothFactor;

        this.x += offX;
        this.y += offY;

        this.rotation = Math.atan2(offY, offX) + Math.PI / 2;

        this.addSmokeParticle(scale);  
    }

    public detonate(): void {

        this.visible = true;
        this.detonated = true;
        this.mortarImage.visible = false;

        const explosionEffect = this.scene.add.sprite(0, 0, "texture_atlas_3");
        explosionEffect.setScale(1.8 + .2 * this.anutoMortar.turret.level);
        this.add(explosionEffect);

        explosionEffect.anims.play("explosion_plus");

        explosionEffect.on("animationcomplete", () => {
            BoardContainer.currentInstance.removeRocket(this);
        }, this);

        switch (this.anutoMortar.turret.level) {
            case 1:
                AudioManager.playSound("explosion", false, .6);
                break;
            case 2:
                AudioManager.playSound("explosion");
                break;
            case 3:
                AudioManager.playSound("explosion_max");
                break;
            default:
                break;
        }
    }

    private addSmokeParticle(scale: number): void {

        this.f ++;

        let n =  GameVars.timeStepFactor === 1 ? 5 : 2;

        if (this.f === n) {

            this.f = 0;

            const board = BoardContainer.currentInstance.board;

            const x = 2 - 4 * Math.random() + this.x;
            const y = 2 - 4 * Math.random() + this.y;

            const smokeParticle = new Phaser.GameObjects.Image(this.scene, x, y, "texture_atlas_3", "smoke_particle");
            smokeParticle.angle = 360 * Math.random();
            smokeParticle.setScale(0);

            const i = board.getIndex(this);

            board.addAt(smokeParticle, i - 1);

            this.scene.tweens.add({
                targets: smokeParticle,
                scaleX: scale * .3 + .1 * Math.random(),
                scaleY: scale * .3 + .1 * Math.random(),
                duration: 350 + 150 * Math.random(),
                onComplete: () => {
                    BattleScene.currentInstance.tweens.add({
                        targets: smokeParticle,
                        alpha: 0,
                        duration: 350,
                        delay: 300 * Math.random(),
                        onComplete: () => {
                            smokeParticle.destroy();
                        },
                        onCompleteScope: this
                    });
                },
                onCompleteScope: this
            });
        }
    }
}
